var map = {
	"./logo__1.svg": 613,
	"./logo__11.svg": 614,
	"./logo__12.svg": 615,
	"./logo__13.svg": 616,
	"./logo__14.svg": 617,
	"./logo__15.svg": 618,
	"./logo__2.svg": 619,
	"./logo__24.svg": 620,
	"./logo__3.svg": 621,
	"./logo__4.svg": 622,
	"./logo__44.svg": 623,
	"./logo__5.svg": 624,
	"./logo__6.svg": 625,
	"./logo__62.svg": 626,
	"./logo__7.svg": 627,
	"./logo__8.svg": 628,
	"./logo__9.svg": 629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 906;